/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Product_SubcategoryInputs */

const en_reference_dataset_product_subcategory = /** @type {(inputs: Reference_Dataset_Product_SubcategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product subcategories`)
};

/**
* | output |
* | --- |
* | "Product subcategories" |
*
* @param {Reference_Dataset_Product_SubcategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_product_subcategory = /** @type {((inputs?: Reference_Dataset_Product_SubcategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Product_SubcategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_product_subcategory(inputs)
});